module.exports = __webpack_public_path__ + "media/any-angle.5fd272e6.mp4";